/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Wechat_DescriptionInputs */

const en_admin_settings_groups_wechat_description = /** @type {(inputs: Admin_Settings_Groups_Wechat_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WeChat Pay gateway (native)`)
};

/**
* | output |
* | --- |
* | "WeChat Pay gateway (native)" |
*
* @param {Admin_Settings_Groups_Wechat_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_wechat_description = /** @type {((inputs?: Admin_Settings_Groups_Wechat_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Wechat_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_wechat_description(inputs)
});
export { admin_settings_groups_wechat_description as "admin.settings.groups.wechat.description" }